<template>
  <div>
    <h3 class="modal-title"> BOARD </h3>

    <b-form-group :class="{'error-input' : $v.data_board.title.$error}">
      <label> Board Title </label>
      <j-input
        v-model="$v.data_board.title.$model"
        :max-length="255"
        placeholder="Board Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_board.board.$error}">
      <label> Select Board </label>
      <j-single-select
        v-model="$v.data_board.board.$model"
        :options="list_board"
        label="name"
        value-format="object"
        placeholder="Choose Board"/>
        <!-- <p
        class="c--approved float-to-right cursor-pointer"
        @click="addNewBoard">
        Create Board
      </p> -->
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_board.field.$error}">
      <label> Select Field </label>
      <j-multi-select
        v-model="$v.data_board.field.$model"
        :options="list_field"
        label="name"
        value-format="object"
        placeholder="Select Field"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeBoard">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveBoard">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal
      ref="modalCreateBoard"
      class="mod-form"
      centered>
      <label>CREATE BOARD</label>
      <b-form-group :class="{'error-input' : $v.data_create_board.name.$error}">
        <label> Board Name </label>
        <j-input
          v-model="$v.data_create_board.name.$model"
          :max-length="255"
          placeholder="Board Name"/>
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.data_create_board.description.$error}">
        <label> Description </label>
        <j-textarea
          v-model="$v.data_create_board.description.$model"
          :max-length="300"
          placeholder="Description"/>
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn blue m__r--5"
              @click="createBoard">
              Finish
            </b-button>
            <b-button
              class="btn gray"
              @click="closeCreateBoard">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_board: {
      title: {
        required,
      },
      board: {
        required,
      },
      field: {

      },
    },
    data_create_board: {
      name: {
        required,
      },
      description: {

      },
    },
  },
  data() {
    return {
      data_board: {
        title: '',
        board: null,
        field: [],
      },
      data_create_board: {
        name: '',
        description: '',
      },
      list_field: [],
      data_field: [],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_board', 'new_board_id']),

    // BOARD SECTION
    generateDataBoard() {
      const dataField = {
        field: this.data_board.field.map(val => val.id),
        field_name: this.data_board.field.map(val => val.name),
      };

      const data = {
        value_id: `${this.data_board.board.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_board.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },

    generateDataBoardUpdate() {
      const dataField = {
        field: this.data_board.field.map(val => val.id),
        field_name: this.data_board.field.map(val => val.name),
      };

      const data = {
        value_id: `${this.data_board.board.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_board.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
    new_board_id(data) {
      this.getListBoard();
      this.data_board.board = {
        id: data,
      };
    },

    list_board(data) {
      if (this.modeEdit) {
        const dataBoard = data.find(e => e.id === Number(this.dataEdit.value_id));
        this.data_board.board = dataBoard;
      }
    },

    // eslint-disable-next-line
    'data_board.board': function(data) {
      const req = {
        additional_info_block: {
          id: Number(data.input_value),
        },
      };
      this.getDetailForms(req).then((res) => {
        const dataAdditional = res.additional_info.filter(filed => filed.is_delete === false);
        this.list_field = dataAdditional;
        this.data_board.field = [];

        if (this.data_field.length > 0) {
          dataAdditional.forEach((element) => {
            if (this.data_field.includes(element.id)) {
              this.data_board.field.push(element);
            }
          });
        }
      });
    },
  },
  mounted() {
    this.getListBoard();

    if (this.modeEdit) {
      this.data_board.title = this.dataEdit.name;

      const dataField = JSON.parse(this.dataEdit.info);
      this.data_field = dataField.field;
      // this.data_board.board = {
      //   id: Number(this.dataEdit.value_id),
      // };
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getListBoard', 'createNewBoard', 'getDetailForms']),

    saveBoard() {
      this.$v.data_board.$touch();
      if (!this.$v.data_board.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataBoard,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataBoardUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.$emit('close-field');
        this.data_board.title = '';
        this.data_board.board = null;
        setTimeout(() => {
          this.$v.data_board.$reset();
        }, 1000);
      }
    },

    closeBoard() {
      this.$emit('close-field');
      this.data_board.title = '';
      this.data_board.board = null;
      setTimeout(() => {
        this.$v.data_board.$reset();
      }, 1000);
    },

    addNewBoard() {
      this.$refs.modalCreateBoard.show();
    },

    createBoard() {
      this.$v.data_create_board.$touch();
      if (!this.$v.data_create_board.$error) {
        const dataParam = {
          additional_info: [],
          description: this.data_create_board.description,
          id: 0,
          is_delete: false,
          name: this.data_create_board.name,
          smart_connect: {
            id: 0,
            is_use_amount: false,
            is_use_category: false,
            product_types: [],
          },
        };
        this.createNewBoard(dataParam);

        this.closeCreateBoard();
      }
    },

    closeCreateBoard() {
      this.$refs.modalCreateBoard.hide();
      this.data_create_board.name = '';
      this.data_create_board.description = '';
      setTimeout(() => {
        this.$v.data_create_board.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jBoardSetup.vue